module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/en_kyushu-19b7a0a1161eef82089503e1ce3a750c.jpg";